export enum EmployeeUploadType {
  Keep = 0,
  Remove = 1,
}
